module.exports = __webpack_public_path__ + "img/android-chrome-512x512.0ff1bc4d.png";